module.exports = __webpack_public_path__ + "static/media/level-up.bd6ee4c1.ogg";